module.exports = __webpack_public_path__ + "static/media/Travel Guru.dca6b4b7.png";